import { render, staticRenderFns } from "./EditSchool.vue?vue&type=template&id=8d107724&scoped=true&"
import script from "./EditSchool.vue?vue&type=script&lang=js&"
export * from "./EditSchool.vue?vue&type=script&lang=js&"
import style0 from "./EditSchool.vue?vue&type=style&index=0&id=8d107724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d107724",
  null
  
)

export default component.exports